import { Component } from '@angular/core';
import { ViewController, AlertController, NavController, NavParams, LoadingController, ToastController } from 'ionic-angular';
import { HttpClient } from '../../services/HttpClient';

@Component({
  selector: 'page-add-file',
  templateUrl: 'addFile.html',
  providers: [HttpClient]
})

export class AddFilePage {

  	viewCtrl: ViewController;
  	navCtrl : NavController;
  	navParams : NavParams;
  	httpClient : HttpClient;
  	loadingCtrl : LoadingController;
    alertCtrl : AlertController;
    toastCtrl : ToastController;

    loading;

    filesToUpload: Array<File>;
    tags = '';

    isProfile = false;

	constructor(viewCtrl: ViewController,alertCtrl : AlertController, navCtrl: NavController, navParams: NavParams, httpClient : HttpClient, loadingCtrl : LoadingController, toastCtrl : ToastController) {
		this.viewCtrl = viewCtrl;
		this.navParams = navParams;
		this.navCtrl = navCtrl;
		this.httpClient = httpClient;
		this.loadingCtrl = loadingCtrl;
    this.alertCtrl = alertCtrl;
    this.toastCtrl = toastCtrl;
    this.filesToUpload = [];
    this.isProfile = this.navParams.get('isProfile')?this.navParams.get('isProfile'):false;

    this.init();
	}

  init(){
  }

  fileChangeEvent(fileInput: any){
    this.filesToUpload = <Array<File>> fileInput.target.files;
    console.log(this.filesToUpload)
  }

  onClickSave(){
    if(this.filesToUpload.length>0){
      console.log(this.filesToUpload)
      this.showLoading();
      console.log(this.tags)
      this.httpClient.upload('/files',this.filesToUpload, this.tags, this.isProfile, (data)=>{
        this.hideLoading();
        if(this.isProfile){
          this.viewCtrl.dismiss({filename : data.files[0].filename});
        }else{
          this.viewCtrl.dismiss(true);
        }
      });
    }
  }

  showMessage(message,time){
    let toast = this.toastCtrl.create({
      message : message,
      duration : time,
      position : 'top'
    });
    toast.present();
  }

  showLoading(){
    this.loading = this.loadingCtrl.create({
      content : 'Guardando la información...'
    });
    this.loading.present();
  }

  hideLoading(){
    this.loading.dismiss();
  }

  dismiss(reload){
    this.viewCtrl.dismiss(reload);
  }
}



// WEBPACK FOOTER //
// ./src/util/addFile/addFile.ts